module.exports = __webpack_public_path__ + "static/media/CV.97b43b83.pdf";